import classNames from "classnames";
import styles from "../css/LearningCorrectIncorrectCard.module.css";
import { ReactComponent as CorrectIcon } from "../../../img/iconImgAlllCorrectLearning.svg";
import { ReactComponent as IncorrectIcon } from "../../../img/iconImgAlllIncorrectLearning.svg";
import { useTranslation } from "react-i18next";
import { toDecimalString } from "../strings";

interface LearningCorrectIncorrectCardProps {
  showing: boolean;
  type: "correcet" | "incorrect";
  termCount: number;
  onClick: () => void;
}

function LearningCorrectIncorrectCard(
  props: LearningCorrectIncorrectCardProps
) {
  const { t } = useTranslation();

  const typeString =
    props.type === "correcet" ? t("CorrectAnswer") : t("IncorrectAnswer");

  const valueString = toDecimalString(props.termCount);

  return (
    <>
      <button
        type="button"
        className={classNames(styles.button, {
          [styles.correct]: props.type === "correcet",
          [styles.incorrect]: props.type === "incorrect",
        })}
        onClick={props.onClick}
      >
        <div className={styles.titleContainer}>
          {props.type === "correcet" && (
            <CorrectIcon className={styles.titleIcon} />
          )}
          {props.type === "incorrect" && (
            <IncorrectIcon className={styles.titleIcon} />
          )}
          <span className={styles.titleText}>{typeString}</span>
        </div>

        <div className={styles.valueContainer}>
          <span className={styles.valueText}>{valueString}</span>
        </div>
      </button>
    </>
  );
}

export default LearningCorrectIncorrectCard;
